<app-grid *ngIf="!loading"
  [columnDefs]="columDef"
  [rowData]="rowData"
  [selectedProject]="selectedProject"
/>

<app-loading *ngIf="loading"/>
